export * from "./recorder-config";

export class ConversationState {
  static GREETING_INCOMPLETE = "greeting_incomplete";
  static GREETING_COMPLETE = "greeting_complete";
  static INTRO_INCOMPLETE = "intro_incomplete";
  static INTRO_COMPLETE = "intro_complete";
  static FIRST_QUE_INCOMPLETE = "first_que_incomplete";
  static FIRST_QUE_COMPLETE = "first_que_complete";
  static CURRENT_QUE_INCOMPLETE = "current_que_incomplete";
  static CURRENT_QUE_COMPLETE = "current_que_complete";
  static LAST_QUE_INCOMPLETE = "last_que_incomplete";
  static LAST_QUE_COMPLETE = "last_que_complete";
  static ENDING = "ending";
  static ENDED = "ended";
}

export class SessionMode {
  static WEB_VIDEO = "web_video";
  static WEB_VIDEO_WITHOUT_AVATAR = "web_video_without_avatar";
  static WEB_AUDIO = "web_audio";
  static TELEPHONIC = "telephonic";
}

export class BotConstants {
  static APP_NAME = "SofiaWorks"
  static BOT_NAME = "Sofia";
  static INTERRUPTION_STR="/|/|interrupt|/|/"
  static CLT_INTERRUPTION_STR="/|/|clt_interrupt|/|/"
  static CLEAR_BOT_CAPTIONS_STR="/|/|clear_bot_captions|/|/"
  static VIDEO_AVATAR_ID = "Katya_Chair_Sitting_public";
  static VIDEO_VOICE_ID = "2f72ee82b83d4b00af16c4771d611752";
  static AUDIO_VOICE_ID = "Crm8VULvkVs5ZBDa1Ixm";
}
